<script setup lang="ts">
import { RouterView, useRoute } from 'vue-router'

import imgUrl from '../../../assets/clinishift-logo-manager-portal-short.png'

// 7 columns (a week) x 4 rows. Values: 0 empty, 1 teal shift, 2 amber shift.
const rota = [
  0, 1, 1, 0, 2, 0, 0, 1, 0, 0, 1, 0, 0, 2, 0, 2, 1, 0, 1, 1, 0, 0, 0, 0, 2, 0,
  1, 0,
]

const route = useRoute()
</script>

<template>
  <div class="shell grid">
    <aside class="brand-panel">
      <RouterLink to="/" class="wordmark">
        <div class="shrink-0">
          <Image width="32" height="32" :src="imgUrl" alt="CliniShift Logo" />
        </div>
      </RouterLink>
      <div class="panel-body">
        <div class="rota-grid" aria-hidden="true">
          <span
            v-for="(cell, i) in rota"
            :key="i"
            class="cell"
            :class="{ teal: cell === 1, amber: cell === 2 }"
            :style="{ animationDelay: `${i * 28}ms` }"
          />
        </div>
        <p class="tagline">The week, sorted.</p>
        <p class="subline">Schedules your team can actually rely on.</p>
      </div>
    </aside>

    <main class="content">
      <div class="w-full max-w-lg">
        <router-view v-slot="{ Component }">
          <transition name="fade" mode="out-in">
            <div :key="route.path" class="w-full">
              <component :is="Component" />
            </div>
          </transition>
        </router-view>
      </div>
    </main>
  </div>
</template>

<style scoped>
.shell {
  min-height: 100vh;
  min-height: 100dvh;
  display: grid;
  grid-template-columns: minmax(300px, 2fr) 3fr;
}

.brand-panel {
  background: var(--color-sky-900);
  color: #eef2f4;
  padding: 36px 40px;
  display: flex;
  flex-direction: column;
}
.wordmark {
  font-family: var(--font-barlow);
  font-weight: 600;
  font-size: 22px;
  color: #fff;
  text-decoration: none;
  letter-spacing: -0.01em;
}
.panel-body {
  margin: auto 0;
  padding: 48px 0;
}

.rota-grid {
  display: grid;
  grid-template-columns: repeat(7, 26px);
  gap: 7px;
  margin-bottom: 32px;
}
.cell {
  width: 26px;
  height: 26px;
  border-radius: 6px;
  background: rgb(255 255 255 / 0.18);
  opacity: 0;
  animation: cell-in 420ms ease forwards;
}
.cell.teal {
  background: #1a9a86;
}
.cell.amber {
  background: #d9963a;
}
@keyframes cell-in {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
@media (prefers-reduced-motion: reduce) {
  .cell {
    opacity: 1;
    animation: none;
  }
}

.tagline {
  font-family: var(--font-barlow);
  font-weight: 600;
  font-size: 30px;
  line-height: 1.2;
}
.subline {
  margin-top: 10px;
  color: rgb(238 242 244 / 0.65);
  max-width: 32ch;
}

.content {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 64px 24px;
}
@media (max-width: 860px) {
  .shell {
    grid-template-columns: 1fr;
  }
  .brand-panel {
    flex-direction: row;
    align-items: center;
    gap: 16px;
    padding: 16px 20px;
  }
  .panel-body,
  .rota-grid,
  .subline {
    display: none;
  }
  .content {
    padding: 32px 20px 64px;
  }
}
</style>
